import {connect, IConnectProps} from 'globx-react';
import * as React               from 'react';
import {Subject}                from 'rxjs';

import StoreName              from '../../../../../State/Shared/Constants/StoreName';
import IPlayerStores          from '../../../../../State/Shared/Interfaces/IPlayerStores';
import Captions               from '../../../../../State/Stores/Captions/Captions';
import {PLAYER_CAPTIONS_MENU} from '../../../../Shared/Constants/TestIds';
import IUiEventsStreamPayload from '../../../../Shared/Interfaces/IUiEventsStreamPayload';
import renderTestId           from '../../../Util/renderTestId';
import CaptionsOption         from '../CaptionsOption';

import * as styles from './captionsMenu.css';

interface ICaptionsMenuProps extends IConnectProps<Captions, IPlayerStores> {
    uiEvents$: Subject<IUiEventsStreamPayload>;
}

@connect(StoreName.CAPTIONS)
class CaptionsMenu extends React.Component<ICaptionsMenuProps> {
    public shouldComponentUpdate(nextProps: ICaptionsMenuProps): boolean {
        return nextProps.value.tracks !== this.props.value.tracks;
    }

    public render(): JSX.Element {
        const {uiEvents$, value, stores} = this.props;
        const {config} = stores;
        const {tracks} = value;

        const captionsConfig = config.value.captions;

        if (tracks.length === 0 || !captionsConfig.enable) return null;

        return (
            <div
                className={styles.menu}
                data-test-id={renderTestId(PLAYER_CAPTIONS_MENU)}
            >
                <div className={styles.menuHeader}>
                    <div className={styles.menuTitle}>
                        Subtitles
                    </div>
                </div>
                <div className={styles.menuOptionsWrap}>
                    <div className={styles.menuOptions}>
                        <CaptionsOption
                            label="Off"
                            selected={!value.areCaptionsActive}
                            language={null}
                            uiEvents$={uiEvents$}
                        />
                        {
                            tracks.map(track =>
                                <CaptionsOption
                                    key={track.index}
                                    language={track.language}
                                    label={track.label}
                                    selected={track.isActive}
                                    uiEvents$={uiEvents$}
                                />
                            )
                        }
                    </div>
                    <div className={styles.bottomGradient} />
                </div>
                <div className={styles.menuFooter} />
            </div>
        );
    }
}

export default CaptionsMenu;